import { AccessDeniedError, UnexpectedError } from "../../domain/errors";
import { UnauthorizedError } from "../../domain/errors/unauthorized-error";
import { Product } from "../../domain/models/product-model";

import { LoadProductListByManyCodes } from "../../domain/usecases/load-product-list-by-many-codes";
import { HttpClient, HttpStatusCode } from "../protocols/http";

export class DbLoadProductListByManyCodes
  implements LoadProductListByManyCodes {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient
  ) { }
  async load(codes: string[]): Promise<Product[]> {
    const res = await this.httpClient.request({
      url: this.url,
      method: "post",
      body: { codes },
    });

    switch (res.statusCode) {
      case HttpStatusCode.ok:
        return res.body || [];
      default:
        throw new UnexpectedError();
    }
  }
}
